<p>doc-oferta-postulantes works!</p><div class="app-content content">
    <div class="content-wrapper">
      <div class="content-header row mb-1">
        <app-breadcrumb class="col-12" [breadcrumb]="breadcrumb"></app-breadcrumb>
      </div>
      <div class="content-body" *ngIf="dataOferta">
        <section id="list-postulantes-oferta">
          <div class="row">
            <h5 class="content-header-title">{{ dataOferta?.descripcionPuesto }} | {{ dataOferta?.lugar }}</h5>
            <br><br>
          </div>
          <div class="col-md-12">
            <div *ngFor="let postulante of dataOferta?.listaPostulantes" class="col-md-12" >
              <a href="javascript:void(0)" class="card-link" (click)="mostrarDetalle(postulante)">
                <div class="card pull-up">
                  <div class="card-content">
                    <div class="media align-items-stretch">
                      <div class="p-2 media-middle">
                        <h4 class="secondary">{{ convertDate(postulante.fechaPostulacion) }}</h4>
                        <h2 class="text-bold-600" [ngClass]="{'success' : postulante?.postulacion==='Aceptada', 
                        'warning' : postulante?.postulacion==='En espera', 'danger' : postulante?.postulacion==='Rechazada'}">
                        {{ postulante.nombre }}</h2>
                        <h2 class="text-bold-600" [ngClass]="{'success' : postulante?.postulacion==='Aceptada', 
                        'warning' : postulante?.postulacion==='En espera', 'danger' : postulante?.postulacion==='Rechazada'}">
                        {{ postulante.apellido }}</h2>
                        <h4>{{postulante.edad}} años</h4>
                      </div>
                      <div class="media-body p-2">
                        <h3>{{ postulante.area }}</h3>
                        <h4 class="text-bold-600">{{ postulante.descripcionEgresado }}</h4>
                      </div>
                      <div *ngIf="postulante?.postulacion==='Rechazada'" class="media-right bg-danger p-2 media-middle rounded-right">
                        <a><i class="feather ft-phone-missed font-large-2 text-white"></i></a>                        
                      </div>
                      <div *ngIf="postulante?.postulacion==='Aceptada'" class="media-right bg-success p-2 media-middle rounded-right">
                        <a><i class="feather ft-check-circle font-large-2 text-white"></i></a>                        
                      </div>
                      <div *ngIf="postulante?.postulacion==='En espera'" class="media-right bg-warning p-2 media-middle rounded-right">
                        <a><i class="icon-calendar font-large-2 text-white"></i></a>                        
                      </div>
                    </div>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </section>
      </div>
    </div> 
  </div>
